import React, {useEffect, useRef} from 'react';
import {Box, Typography} from '@mui/material';
import './DocCountSummaryView.scss';

export interface SummaryItem {
  label: string;
  value: number | string;
}

interface Props {
  leftItems: SummaryItem[];
  rightItems: SummaryItem[];
}

const CommonSummaryView: React.FC<Props> = ({leftItems, rightItems}) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width;

        if (width < 688) {
          (element as any).style.flexDirection = 'column';
          (element as any).style.gap = '0rem';
        } else {
          (element as any).style.flexDirection = 'row';
          (element as any).style.gap = '4rem';
        }
      }
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const renderColumn = (items: SummaryItem[]) => (
    <Box className="left-side-container">
      {items.map((item, index) => (
        <Box
          key={item.label}
          className={`content-row ${
            index < items.length - 1 ? 'content-row-border' : ''
          }`}
        >
          <Typography
            className="typo-text label2_size title-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-label-${index}`}
          >
            {item.label}
          </Typography>

          <Typography
            className="typo-text label2_size count-label"
            tabIndex={0}
            data-testid={`doc-count-summary-view-value-${index}`}
          >
            {typeof item.value === 'number'
              ? item.value.toLocaleString()
              : item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <Box ref={elementRef} className="document-count-summary">
      {renderColumn(leftItems)}
      {renderColumn(rightItems)}
    </Box>
  );
};

export default React.memo(CommonSummaryView);
